import React, { useState, useEffect } from 'react';
import Button from '../common/Button';
import Input from '../common/Input';
import Textarea from '../common/Textarea';
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from '../common/Card';
import { FiSave, FiX } from 'react-icons/fi';

const JDForm = ({ jd, onSave, onCancel }) => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // 当JD变化时更新表单
  useEffect(() => {
    if (jd) {
      setTitle(jd.title || '');
      setContent(jd.content || '');
    } else {
      setTitle('');
      setContent('');
    }
    setErrors({});
  }, [jd]);

  const validate = () => {
    const newErrors = {};
    if (!title.trim()) {
      newErrors.title = '标题不能为空';
    }
    if (!content.trim()) {
      newErrors.content = '内容不能为空';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validate()) {
      return;
    }
    
    setLoading(true);
    
    try {
      await onSave({
        id: jd?.id,
        title: title.trim(),
        content: content.trim(),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="h-full flex flex-col">
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="text-xl">
          {jd ? '编辑职位描述' : '添加职位描述'}
        </CardTitle>
        <Button
          variant="ghost"
          size="sm"
          onClick={onCancel}
          className="h-8 w-8 p-0"
          aria-label="关闭"
        >
          <FiX className="h-4 w-4" />
        </Button>
      </CardHeader>
      <CardContent className="flex-grow">
        <form id="jd-form" onSubmit={handleSubmit} className="space-y-4 h-full flex flex-col">
          <div className="space-y-2">
            <label htmlFor="title" className="text-sm font-medium">
              标题
            </label>
            <Input
              id="title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="输入职位标题"
              error={errors.title}
            />
          </div>
          
          <div className="space-y-2 flex-grow">
            <label htmlFor="content" className="text-sm font-medium">
              内容
            </label>
            <Textarea
              id="content"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              placeholder="输入职位描述内容"
              className="h-[calc(100%-2rem)]"
              error={errors.content}
            />
          </div>
        </form>
      </CardContent>
      <CardFooter className="border-t pt-4">
        <div className="flex justify-end gap-2 w-full">
          <Button
            variant="outline"
            onClick={onCancel}
            disabled={loading}
          >
            取消
          </Button>
          <Button
            type="submit"
            form="jd-form"
            disabled={loading}
            className="flex items-center gap-1"
          >
            <FiSave className="h-4 w-4" />
            {loading ? '保存中...' : '保存'}
          </Button>
        </div>
      </CardFooter>
    </Card>
  );
};

export default JDForm;
